/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Action } from '../models';
// @ts-ignore
import type { AdditionalAnswer } from '../models';
// @ts-ignore
import type { CallDirection } from '../models';
// @ts-ignore
import type { CallLogCreateDTO } from '../models';
// @ts-ignore
import type { CallLogPostProcessingHistoryDTO } from '../models';
// @ts-ignore
import type { CallLogResponseDTO } from '../models';
// @ts-ignore
import type { CallLogSearchResponseDTO } from '../models';
// @ts-ignore
import type { CallLogSortField } from '../models';
// @ts-ignore
import type { ChannelType } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageCallLogResponseDTO } from '../models';
// @ts-ignore
import type { PostProcessingDryRunRequestDTO } from '../models';
// @ts-ignore
import type { PostProcessingEnqueueResponseDTO } from '../models';
// @ts-ignore
import type { SearchStatsResponseDTO } from '../models';
// @ts-ignore
import type { SearchSuggestionsResponseDTO } from '../models';
// @ts-ignore
import type { SortDirection } from '../models';
/**
 * CallLogsApi - axios parameter creator
 * @export
 */
export const CallLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new call log. Requires \'call_log:write\' permission.
         * @summary Create Call Log
         * @param {CallLogCreateDTO} callLogCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCallLogApiV1CallLogsPost: async (callLogCreateDTO: CallLogCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogCreateDTO' is not null or undefined
            assertParamExists('createCallLogApiV1CallLogsPost', 'callLogCreateDTO', callLogCreateDTO)
            const localVarPath = `/api/v1/call-logs/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callLogCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new call log. Requires \'call_log:write\' permission.
         * @summary Create Call Log
         * @param {CallLogCreateDTO} callLogCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCallLogApiV1CallLogsPost_1: async (callLogCreateDTO: CallLogCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogCreateDTO' is not null or undefined
            assertParamExists('createCallLogApiV1CallLogsPost_1', 'callLogCreateDTO', callLogCreateDTO)
            const localVarPath = `/api/v1/call-logs/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callLogCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a call log with its associated conversation data (GDPR-compliant deletion).  **GDPR Compliance**: Permanently deletes the call log and associated conversation data.  **What gets deleted:** - Call log record - Conversation transcript - All conversation turns - Additional answers  **What gets preserved:** - Contact record (unaffected) - Callbacks (call_log_id set to NULL, can still be accessed) - Calendar events/appointments (unaffected)  **Permissions**: Requires `call_log:write` permission  **Multi-tenant**: Automatically filtered to current organization  **Audit Logging**: This operation is logged with full context for compliance audit.
         * @summary Delete Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCallLogApiV1CallLogsCallLogIdDelete: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('deleteCallLogApiV1CallLogsCallLogIdDelete', 'callLogId', callLogId)
            const localVarPath = `/api/v1/call-logs/{call_log_id}`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a call log with its associated conversation data (GDPR-compliant deletion).  **GDPR Compliance**: Permanently deletes the call log and associated conversation data.  **What gets deleted:** - Call log record - Conversation transcript - All conversation turns - Additional answers  **What gets preserved:** - Contact record (unaffected) - Callbacks (call_log_id set to NULL, can still be accessed) - Calendar events/appointments (unaffected)  **Permissions**: Requires `call_log:write` permission  **Multi-tenant**: Automatically filtered to current organization  **Audit Logging**: This operation is logged with full context for compliance audit.
         * @summary Delete Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCallLogApiV1CallLogsCallLogIdDelete_2: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('deleteCallLogApiV1CallLogsCallLogIdDelete_2', 'callLogId', callLogId)
            const localVarPath = `/api/v1/call-logs/{call_log_id}`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Queue a dry-run replay of post-processing for an existing call log. Requires \'call_log:write\' permission.
         * @summary Enqueue Post Processing Dry Run
         * @param {string} callLogId 
         * @param {PostProcessingDryRunRequestDTO} postProcessingDryRunRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost: async (callLogId: string, postProcessingDryRunRequestDTO: PostProcessingDryRunRequestDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost', 'callLogId', callLogId)
            // verify required parameter 'postProcessingDryRunRequestDTO' is not null or undefined
            assertParamExists('enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost', 'postProcessingDryRunRequestDTO', postProcessingDryRunRequestDTO)
            const localVarPath = `/api/v1/call-logs/{call_log_id}/post-processing/dry-run`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postProcessingDryRunRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Queue a dry-run replay of post-processing for an existing call log. Requires \'call_log:write\' permission.
         * @summary Enqueue Post Processing Dry Run
         * @param {string} callLogId 
         * @param {PostProcessingDryRunRequestDTO} postProcessingDryRunRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost_3: async (callLogId: string, postProcessingDryRunRequestDTO: PostProcessingDryRunRequestDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost_3', 'callLogId', callLogId)
            // verify required parameter 'postProcessingDryRunRequestDTO' is not null or undefined
            assertParamExists('enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost_3', 'postProcessingDryRunRequestDTO', postProcessingDryRunRequestDTO)
            const localVarPath = `/api/v1/call-logs/{call_log_id}/post-processing/dry-run`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postProcessingDryRunRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the action associated with a call log. Returns None if no action is associated. Requires \'call_log:view\' permission.
         * @summary Get Call Log Action
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogActionApiV1CallLogsCallLogIdActionGet: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getCallLogActionApiV1CallLogsCallLogIdActionGet', 'callLogId', callLogId)
            const localVarPath = `/api/v1/call-logs/{call_log_id}/action`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the action associated with a call log. Returns None if no action is associated. Requires \'call_log:view\' permission.
         * @summary Get Call Log Action
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogActionApiV1CallLogsCallLogIdActionGet_4: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getCallLogActionApiV1CallLogsCallLogIdActionGet_4', 'callLogId', callLogId)
            const localVarPath = `/api/v1/call-logs/{call_log_id}/action`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all additional answers for a call log. Requires \'call_log:view\' permission.
         * @summary Get Call Log Answers
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet', 'callLogId', callLogId)
            const localVarPath = `/api/v1/call-logs/{call_log_id}/answers`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all additional answers for a call log. Requires \'call_log:view\' permission.
         * @summary Get Call Log Answers
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet_5: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet_5', 'callLogId', callLogId)
            const localVarPath = `/api/v1/call-logs/{call_log_id}/answers`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific call log by ID. Requires \'call_log:view\' permission.
         * @summary Get Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogApiV1CallLogsCallLogIdGet: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getCallLogApiV1CallLogsCallLogIdGet', 'callLogId', callLogId)
            const localVarPath = `/api/v1/call-logs/{call_log_id}`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific call log by ID. Requires \'call_log:view\' permission.
         * @summary Get Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogApiV1CallLogsCallLogIdGet_6: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getCallLogApiV1CallLogsCallLogIdGet_6', 'callLogId', callLogId)
            const localVarPath = `/api/v1/call-logs/{call_log_id}`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statistics for a call log search query. Requires \'call_log:view\' permission.
         * @summary Get Call Log Search Stats
         * @param {string} q Search query
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogSearchStatsApiV1CallLogsSearchStatsGet: async (q: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('getCallLogSearchStatsApiV1CallLogsSearchStatsGet', 'q', q)
            const localVarPath = `/api/v1/call-logs/search/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statistics for a call log search query. Requires \'call_log:view\' permission.
         * @summary Get Call Log Search Stats
         * @param {string} q Search query
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogSearchStatsApiV1CallLogsSearchStatsGet_7: async (q: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('getCallLogSearchStatsApiV1CallLogsSearchStatsGet_7', 'q', q)
            const localVarPath = `/api/v1/call-logs/search/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get search suggestions for call logs based on partial query. Requires \'call_log:view\' permission.
         * @summary Get Call Log Search Suggestions
         * @param {string} q Partial search query
         * @param {number} [maxSuggestions] Maximum suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet: async (q: string, maxSuggestions?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet', 'q', q)
            const localVarPath = `/api/v1/call-logs/search/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (maxSuggestions !== undefined) {
                localVarQueryParameter['max_suggestions'] = maxSuggestions;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get search suggestions for call logs based on partial query. Requires \'call_log:view\' permission.
         * @summary Get Call Log Search Suggestions
         * @param {string} q Partial search query
         * @param {number} [maxSuggestions] Maximum suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet_8: async (q: string, maxSuggestions?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet_8', 'q', q)
            const localVarPath = `/api/v1/call-logs/search/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (maxSuggestions !== undefined) {
                localVarQueryParameter['max_suggestions'] = maxSuggestions;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a call log with all related details (answers) loaded. Requires \'call_log:view\' permission.
         * @summary Get Call Log With Details
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet', 'callLogId', callLogId)
            const localVarPath = `/api/v1/call-logs/{call_log_id}/details`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a call log with all related details (answers) loaded. Requires \'call_log:view\' permission.
         * @summary Get Call Log With Details
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet_9: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet_9', 'callLogId', callLogId)
            const localVarPath = `/api/v1/call-logs/{call_log_id}/details`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the full ordered post-processing history for a call log. Requires \'call_log:view\' permission.
         * @summary Get Post Processing History
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet', 'callLogId', callLogId)
            const localVarPath = `/api/v1/call-logs/{call_log_id}/post-processing/logs`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the full ordered post-processing history for a call log. Requires \'call_log:view\' permission.
         * @summary Get Post Processing History
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet_10: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet_10', 'callLogId', callLogId)
            const localVarPath = `/api/v1/call-logs/{call_log_id}/post-processing/logs`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all call logs in the current user\'s organization. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound) and channel (phone/chat). Requires \'call_log:view\' permission.
         * @summary List Call Logs
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallLogsApiV1CallLogsGet: async (sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, channel?: ChannelType | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/call-logs/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (callDirection !== undefined) {
                localVarQueryParameter['call_direction'] = callDirection;
            }

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all call logs in the current user\'s organization. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound) and channel (phone/chat). Requires \'call_log:view\' permission.
         * @summary List Call Logs
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallLogsApiV1CallLogsGet_11: async (sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, channel?: ChannelType | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/call-logs/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (callDirection !== undefined) {
                localVarQueryParameter['call_direction'] = callDirection;
            }

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List call logs for a specific agent. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
         * @summary List Call Logs By Agent
         * @param {string} agentId 
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallLogsByAgentApiV1CallLogsAgentAgentIdGet: async (agentId: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('listCallLogsByAgentApiV1CallLogsAgentAgentIdGet', 'agentId', agentId)
            const localVarPath = `/api/v1/call-logs/agent/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (callDirection !== undefined) {
                localVarQueryParameter['call_direction'] = callDirection;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List call logs for a specific agent. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
         * @summary List Call Logs By Agent
         * @param {string} agentId 
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallLogsByAgentApiV1CallLogsAgentAgentIdGet_12: async (agentId: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('listCallLogsByAgentApiV1CallLogsAgentAgentIdGet_12', 'agentId', agentId)
            const localVarPath = `/api/v1/call-logs/agent/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (callDirection !== undefined) {
                localVarQueryParameter['call_direction'] = callDirection;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List call logs from a specific phone number. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
         * @summary List Call Logs By Phone
         * @param {string} phoneNumber 
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet: async (phoneNumber: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumber' is not null or undefined
            assertParamExists('listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet', 'phoneNumber', phoneNumber)
            const localVarPath = `/api/v1/call-logs/phone/{phone_number}`
                .replace(`{${"phone_number"}}`, encodeURIComponent(String(phoneNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (callDirection !== undefined) {
                localVarQueryParameter['call_direction'] = callDirection;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List call logs from a specific phone number. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
         * @summary List Call Logs By Phone
         * @param {string} phoneNumber 
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet_13: async (phoneNumber: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumber' is not null or undefined
            assertParamExists('listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet_13', 'phoneNumber', phoneNumber)
            const localVarPath = `/api/v1/call-logs/phone/{phone_number}`
                .replace(`{${"phone_number"}}`, encodeURIComponent(String(phoneNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (callDirection !== undefined) {
                localVarQueryParameter['call_direction'] = callDirection;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search call logs using full-text search and pattern matching. Supports searching by caller names, phone numbers, and call reasons. Optionally filter by channel (phone/chat); None returns all channels. Requires \'call_log:view\' permission.
         * @summary Search Call Logs
         * @param {string} q Search query (names, phone numbers, reasons)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [agentId] Filter by specific agent
         * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
         * @param {boolean} [includeSuggestions] Include search suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCallLogsApiV1CallLogsSearchGet: async (q: string, limit?: number, offset?: number, agentId?: string | null, channel?: ChannelType | null, includeSuggestions?: boolean, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchCallLogsApiV1CallLogsSearchGet', 'q', q)
            const localVarPath = `/api/v1/call-logs/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }

            if (includeSuggestions !== undefined) {
                localVarQueryParameter['include_suggestions'] = includeSuggestions;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search call logs using full-text search and pattern matching. Supports searching by caller names, phone numbers, and call reasons. Optionally filter by channel (phone/chat); None returns all channels. Requires \'call_log:view\' permission.
         * @summary Search Call Logs
         * @param {string} q Search query (names, phone numbers, reasons)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [agentId] Filter by specific agent
         * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
         * @param {boolean} [includeSuggestions] Include search suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCallLogsApiV1CallLogsSearchGet_14: async (q: string, limit?: number, offset?: number, agentId?: string | null, channel?: ChannelType | null, includeSuggestions?: boolean, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchCallLogsApiV1CallLogsSearchGet_14', 'q', q)
            const localVarPath = `/api/v1/call-logs/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }

            if (includeSuggestions !== undefined) {
                localVarQueryParameter['include_suggestions'] = includeSuggestions;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallLogsApi - functional programming interface
 * @export
 */
export const CallLogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallLogsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new call log. Requires \'call_log:write\' permission.
         * @summary Create Call Log
         * @param {CallLogCreateDTO} callLogCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCallLogApiV1CallLogsPost(callLogCreateDTO: CallLogCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallLogResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCallLogApiV1CallLogsPost(callLogCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.createCallLogApiV1CallLogsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new call log. Requires \'call_log:write\' permission.
         * @summary Create Call Log
         * @param {CallLogCreateDTO} callLogCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCallLogApiV1CallLogsPost_1(callLogCreateDTO: CallLogCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallLogResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCallLogApiV1CallLogsPost_1(callLogCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.createCallLogApiV1CallLogsPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a call log with its associated conversation data (GDPR-compliant deletion).  **GDPR Compliance**: Permanently deletes the call log and associated conversation data.  **What gets deleted:** - Call log record - Conversation transcript - All conversation turns - Additional answers  **What gets preserved:** - Contact record (unaffected) - Callbacks (call_log_id set to NULL, can still be accessed) - Calendar events/appointments (unaffected)  **Permissions**: Requires `call_log:write` permission  **Multi-tenant**: Automatically filtered to current organization  **Audit Logging**: This operation is logged with full context for compliance audit.
         * @summary Delete Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCallLogApiV1CallLogsCallLogIdDelete(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCallLogApiV1CallLogsCallLogIdDelete(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.deleteCallLogApiV1CallLogsCallLogIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a call log with its associated conversation data (GDPR-compliant deletion).  **GDPR Compliance**: Permanently deletes the call log and associated conversation data.  **What gets deleted:** - Call log record - Conversation transcript - All conversation turns - Additional answers  **What gets preserved:** - Contact record (unaffected) - Callbacks (call_log_id set to NULL, can still be accessed) - Calendar events/appointments (unaffected)  **Permissions**: Requires `call_log:write` permission  **Multi-tenant**: Automatically filtered to current organization  **Audit Logging**: This operation is logged with full context for compliance audit.
         * @summary Delete Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCallLogApiV1CallLogsCallLogIdDelete_2(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCallLogApiV1CallLogsCallLogIdDelete_2(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.deleteCallLogApiV1CallLogsCallLogIdDelete_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Queue a dry-run replay of post-processing for an existing call log. Requires \'call_log:write\' permission.
         * @summary Enqueue Post Processing Dry Run
         * @param {string} callLogId 
         * @param {PostProcessingDryRunRequestDTO} postProcessingDryRunRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost(callLogId: string, postProcessingDryRunRequestDTO: PostProcessingDryRunRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostProcessingEnqueueResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost(callLogId, postProcessingDryRunRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Queue a dry-run replay of post-processing for an existing call log. Requires \'call_log:write\' permission.
         * @summary Enqueue Post Processing Dry Run
         * @param {string} callLogId 
         * @param {PostProcessingDryRunRequestDTO} postProcessingDryRunRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost_3(callLogId: string, postProcessingDryRunRequestDTO: PostProcessingDryRunRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostProcessingEnqueueResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost_3(callLogId, postProcessingDryRunRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the action associated with a call log. Returns None if no action is associated. Requires \'call_log:view\' permission.
         * @summary Get Call Log Action
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallLogActionApiV1CallLogsCallLogIdActionGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Action>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallLogActionApiV1CallLogsCallLogIdActionGet(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.getCallLogActionApiV1CallLogsCallLogIdActionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the action associated with a call log. Returns None if no action is associated. Requires \'call_log:view\' permission.
         * @summary Get Call Log Action
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallLogActionApiV1CallLogsCallLogIdActionGet_4(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Action>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallLogActionApiV1CallLogsCallLogIdActionGet_4(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.getCallLogActionApiV1CallLogsCallLogIdActionGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all additional answers for a call log. Requires \'call_log:view\' permission.
         * @summary Get Call Log Answers
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdditionalAnswer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all additional answers for a call log. Requires \'call_log:view\' permission.
         * @summary Get Call Log Answers
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet_5(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdditionalAnswer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet_5(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific call log by ID. Requires \'call_log:view\' permission.
         * @summary Get Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallLogApiV1CallLogsCallLogIdGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallLogResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallLogApiV1CallLogsCallLogIdGet(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.getCallLogApiV1CallLogsCallLogIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific call log by ID. Requires \'call_log:view\' permission.
         * @summary Get Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallLogApiV1CallLogsCallLogIdGet_6(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallLogResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallLogApiV1CallLogsCallLogIdGet_6(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.getCallLogApiV1CallLogsCallLogIdGet_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get statistics for a call log search query. Requires \'call_log:view\' permission.
         * @summary Get Call Log Search Stats
         * @param {string} q Search query
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallLogSearchStatsApiV1CallLogsSearchStatsGet(q: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchStatsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallLogSearchStatsApiV1CallLogsSearchStatsGet(q, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.getCallLogSearchStatsApiV1CallLogsSearchStatsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get statistics for a call log search query. Requires \'call_log:view\' permission.
         * @summary Get Call Log Search Stats
         * @param {string} q Search query
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallLogSearchStatsApiV1CallLogsSearchStatsGet_7(q: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchStatsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallLogSearchStatsApiV1CallLogsSearchStatsGet_7(q, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.getCallLogSearchStatsApiV1CallLogsSearchStatsGet_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get search suggestions for call logs based on partial query. Requires \'call_log:view\' permission.
         * @summary Get Call Log Search Suggestions
         * @param {string} q Partial search query
         * @param {number} [maxSuggestions] Maximum suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet(q: string, maxSuggestions?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchSuggestionsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet(q, maxSuggestions, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get search suggestions for call logs based on partial query. Requires \'call_log:view\' permission.
         * @summary Get Call Log Search Suggestions
         * @param {string} q Partial search query
         * @param {number} [maxSuggestions] Maximum suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet_8(q: string, maxSuggestions?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchSuggestionsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet_8(q, maxSuggestions, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a call log with all related details (answers) loaded. Requires \'call_log:view\' permission.
         * @summary Get Call Log With Details
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallLogResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a call log with all related details (answers) loaded. Requires \'call_log:view\' permission.
         * @summary Get Call Log With Details
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet_9(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallLogResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet_9(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet_9']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the full ordered post-processing history for a call log. Requires \'call_log:view\' permission.
         * @summary Get Post Processing History
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallLogPostProcessingHistoryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the full ordered post-processing history for a call log. Requires \'call_log:view\' permission.
         * @summary Get Post Processing History
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet_10(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallLogPostProcessingHistoryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet_10(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet_10']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all call logs in the current user\'s organization. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound) and channel (phone/chat). Requires \'call_log:view\' permission.
         * @summary List Call Logs
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCallLogsApiV1CallLogsGet(sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, channel?: ChannelType | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCallLogResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCallLogsApiV1CallLogsGet(sortField, sortDirection, callDirection, channel, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.listCallLogsApiV1CallLogsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all call logs in the current user\'s organization. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound) and channel (phone/chat). Requires \'call_log:view\' permission.
         * @summary List Call Logs
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCallLogsApiV1CallLogsGet_11(sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, channel?: ChannelType | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCallLogResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCallLogsApiV1CallLogsGet_11(sortField, sortDirection, callDirection, channel, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.listCallLogsApiV1CallLogsGet_11']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List call logs for a specific agent. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
         * @summary List Call Logs By Agent
         * @param {string} agentId 
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCallLogsByAgentApiV1CallLogsAgentAgentIdGet(agentId: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCallLogResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCallLogsByAgentApiV1CallLogsAgentAgentIdGet(agentId, sortField, sortDirection, callDirection, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.listCallLogsByAgentApiV1CallLogsAgentAgentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List call logs for a specific agent. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
         * @summary List Call Logs By Agent
         * @param {string} agentId 
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCallLogsByAgentApiV1CallLogsAgentAgentIdGet_12(agentId: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCallLogResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCallLogsByAgentApiV1CallLogsAgentAgentIdGet_12(agentId, sortField, sortDirection, callDirection, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.listCallLogsByAgentApiV1CallLogsAgentAgentIdGet_12']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List call logs from a specific phone number. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
         * @summary List Call Logs By Phone
         * @param {string} phoneNumber 
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet(phoneNumber: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCallLogResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet(phoneNumber, sortField, sortDirection, callDirection, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List call logs from a specific phone number. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
         * @summary List Call Logs By Phone
         * @param {string} phoneNumber 
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet_13(phoneNumber: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCallLogResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet_13(phoneNumber, sortField, sortDirection, callDirection, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet_13']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search call logs using full-text search and pattern matching. Supports searching by caller names, phone numbers, and call reasons. Optionally filter by channel (phone/chat); None returns all channels. Requires \'call_log:view\' permission.
         * @summary Search Call Logs
         * @param {string} q Search query (names, phone numbers, reasons)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [agentId] Filter by specific agent
         * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
         * @param {boolean} [includeSuggestions] Include search suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCallLogsApiV1CallLogsSearchGet(q: string, limit?: number, offset?: number, agentId?: string | null, channel?: ChannelType | null, includeSuggestions?: boolean, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallLogSearchResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCallLogsApiV1CallLogsSearchGet(q, limit, offset, agentId, channel, includeSuggestions, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.searchCallLogsApiV1CallLogsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search call logs using full-text search and pattern matching. Supports searching by caller names, phone numbers, and call reasons. Optionally filter by channel (phone/chat); None returns all channels. Requires \'call_log:view\' permission.
         * @summary Search Call Logs
         * @param {string} q Search query (names, phone numbers, reasons)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [agentId] Filter by specific agent
         * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
         * @param {boolean} [includeSuggestions] Include search suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCallLogsApiV1CallLogsSearchGet_14(q: string, limit?: number, offset?: number, agentId?: string | null, channel?: ChannelType | null, includeSuggestions?: boolean, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallLogSearchResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCallLogsApiV1CallLogsSearchGet_14(q, limit, offset, agentId, channel, includeSuggestions, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.searchCallLogsApiV1CallLogsSearchGet_14']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CallLogsApi - factory interface
 * @export
 */
export const CallLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallLogsApiFp(configuration)
    return {
        /**
         * Create a new call log. Requires \'call_log:write\' permission.
         * @summary Create Call Log
         * @param {CallLogCreateDTO} callLogCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCallLogApiV1CallLogsPost(callLogCreateDTO: CallLogCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallLogResponseDTO> {
            return localVarFp.createCallLogApiV1CallLogsPost(callLogCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new call log. Requires \'call_log:write\' permission.
         * @summary Create Call Log
         * @param {CallLogCreateDTO} callLogCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCallLogApiV1CallLogsPost_1(callLogCreateDTO: CallLogCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallLogResponseDTO> {
            return localVarFp.createCallLogApiV1CallLogsPost_1(callLogCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a call log with its associated conversation data (GDPR-compliant deletion).  **GDPR Compliance**: Permanently deletes the call log and associated conversation data.  **What gets deleted:** - Call log record - Conversation transcript - All conversation turns - Additional answers  **What gets preserved:** - Contact record (unaffected) - Callbacks (call_log_id set to NULL, can still be accessed) - Calendar events/appointments (unaffected)  **Permissions**: Requires `call_log:write` permission  **Multi-tenant**: Automatically filtered to current organization  **Audit Logging**: This operation is logged with full context for compliance audit.
         * @summary Delete Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCallLogApiV1CallLogsCallLogIdDelete(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCallLogApiV1CallLogsCallLogIdDelete(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a call log with its associated conversation data (GDPR-compliant deletion).  **GDPR Compliance**: Permanently deletes the call log and associated conversation data.  **What gets deleted:** - Call log record - Conversation transcript - All conversation turns - Additional answers  **What gets preserved:** - Contact record (unaffected) - Callbacks (call_log_id set to NULL, can still be accessed) - Calendar events/appointments (unaffected)  **Permissions**: Requires `call_log:write` permission  **Multi-tenant**: Automatically filtered to current organization  **Audit Logging**: This operation is logged with full context for compliance audit.
         * @summary Delete Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCallLogApiV1CallLogsCallLogIdDelete_2(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCallLogApiV1CallLogsCallLogIdDelete_2(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Queue a dry-run replay of post-processing for an existing call log. Requires \'call_log:write\' permission.
         * @summary Enqueue Post Processing Dry Run
         * @param {string} callLogId 
         * @param {PostProcessingDryRunRequestDTO} postProcessingDryRunRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost(callLogId: string, postProcessingDryRunRequestDTO: PostProcessingDryRunRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PostProcessingEnqueueResponseDTO> {
            return localVarFp.enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost(callLogId, postProcessingDryRunRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Queue a dry-run replay of post-processing for an existing call log. Requires \'call_log:write\' permission.
         * @summary Enqueue Post Processing Dry Run
         * @param {string} callLogId 
         * @param {PostProcessingDryRunRequestDTO} postProcessingDryRunRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost_3(callLogId: string, postProcessingDryRunRequestDTO: PostProcessingDryRunRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PostProcessingEnqueueResponseDTO> {
            return localVarFp.enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost_3(callLogId, postProcessingDryRunRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the action associated with a call log. Returns None if no action is associated. Requires \'call_log:view\' permission.
         * @summary Get Call Log Action
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogActionApiV1CallLogsCallLogIdActionGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Action> {
            return localVarFp.getCallLogActionApiV1CallLogsCallLogIdActionGet(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the action associated with a call log. Returns None if no action is associated. Requires \'call_log:view\' permission.
         * @summary Get Call Log Action
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogActionApiV1CallLogsCallLogIdActionGet_4(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Action> {
            return localVarFp.getCallLogActionApiV1CallLogsCallLogIdActionGet_4(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all additional answers for a call log. Requires \'call_log:view\' permission.
         * @summary Get Call Log Answers
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdditionalAnswer>> {
            return localVarFp.getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all additional answers for a call log. Requires \'call_log:view\' permission.
         * @summary Get Call Log Answers
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet_5(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdditionalAnswer>> {
            return localVarFp.getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet_5(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific call log by ID. Requires \'call_log:view\' permission.
         * @summary Get Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogApiV1CallLogsCallLogIdGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallLogResponseDTO> {
            return localVarFp.getCallLogApiV1CallLogsCallLogIdGet(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific call log by ID. Requires \'call_log:view\' permission.
         * @summary Get Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogApiV1CallLogsCallLogIdGet_6(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallLogResponseDTO> {
            return localVarFp.getCallLogApiV1CallLogsCallLogIdGet_6(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get statistics for a call log search query. Requires \'call_log:view\' permission.
         * @summary Get Call Log Search Stats
         * @param {string} q Search query
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogSearchStatsApiV1CallLogsSearchStatsGet(q: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<SearchStatsResponseDTO> {
            return localVarFp.getCallLogSearchStatsApiV1CallLogsSearchStatsGet(q, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get statistics for a call log search query. Requires \'call_log:view\' permission.
         * @summary Get Call Log Search Stats
         * @param {string} q Search query
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogSearchStatsApiV1CallLogsSearchStatsGet_7(q: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<SearchStatsResponseDTO> {
            return localVarFp.getCallLogSearchStatsApiV1CallLogsSearchStatsGet_7(q, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get search suggestions for call logs based on partial query. Requires \'call_log:view\' permission.
         * @summary Get Call Log Search Suggestions
         * @param {string} q Partial search query
         * @param {number} [maxSuggestions] Maximum suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet(q: string, maxSuggestions?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<SearchSuggestionsResponseDTO> {
            return localVarFp.getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet(q, maxSuggestions, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get search suggestions for call logs based on partial query. Requires \'call_log:view\' permission.
         * @summary Get Call Log Search Suggestions
         * @param {string} q Partial search query
         * @param {number} [maxSuggestions] Maximum suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet_8(q: string, maxSuggestions?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<SearchSuggestionsResponseDTO> {
            return localVarFp.getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet_8(q, maxSuggestions, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a call log with all related details (answers) loaded. Requires \'call_log:view\' permission.
         * @summary Get Call Log With Details
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallLogResponseDTO> {
            return localVarFp.getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a call log with all related details (answers) loaded. Requires \'call_log:view\' permission.
         * @summary Get Call Log With Details
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet_9(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallLogResponseDTO> {
            return localVarFp.getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet_9(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the full ordered post-processing history for a call log. Requires \'call_log:view\' permission.
         * @summary Get Post Processing History
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallLogPostProcessingHistoryDTO> {
            return localVarFp.getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the full ordered post-processing history for a call log. Requires \'call_log:view\' permission.
         * @summary Get Post Processing History
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet_10(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallLogPostProcessingHistoryDTO> {
            return localVarFp.getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet_10(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all call logs in the current user\'s organization. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound) and channel (phone/chat). Requires \'call_log:view\' permission.
         * @summary List Call Logs
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallLogsApiV1CallLogsGet(sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, channel?: ChannelType | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageCallLogResponseDTO> {
            return localVarFp.listCallLogsApiV1CallLogsGet(sortField, sortDirection, callDirection, channel, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all call logs in the current user\'s organization. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound) and channel (phone/chat). Requires \'call_log:view\' permission.
         * @summary List Call Logs
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallLogsApiV1CallLogsGet_11(sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, channel?: ChannelType | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageCallLogResponseDTO> {
            return localVarFp.listCallLogsApiV1CallLogsGet_11(sortField, sortDirection, callDirection, channel, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List call logs for a specific agent. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
         * @summary List Call Logs By Agent
         * @param {string} agentId 
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallLogsByAgentApiV1CallLogsAgentAgentIdGet(agentId: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageCallLogResponseDTO> {
            return localVarFp.listCallLogsByAgentApiV1CallLogsAgentAgentIdGet(agentId, sortField, sortDirection, callDirection, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List call logs for a specific agent. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
         * @summary List Call Logs By Agent
         * @param {string} agentId 
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallLogsByAgentApiV1CallLogsAgentAgentIdGet_12(agentId: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageCallLogResponseDTO> {
            return localVarFp.listCallLogsByAgentApiV1CallLogsAgentAgentIdGet_12(agentId, sortField, sortDirection, callDirection, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List call logs from a specific phone number. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
         * @summary List Call Logs By Phone
         * @param {string} phoneNumber 
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet(phoneNumber: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageCallLogResponseDTO> {
            return localVarFp.listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet(phoneNumber, sortField, sortDirection, callDirection, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List call logs from a specific phone number. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
         * @summary List Call Logs By Phone
         * @param {string} phoneNumber 
         * @param {CallLogSortField} [sortField] Field to sort by
         * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
         * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet_13(phoneNumber: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageCallLogResponseDTO> {
            return localVarFp.listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet_13(phoneNumber, sortField, sortDirection, callDirection, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search call logs using full-text search and pattern matching. Supports searching by caller names, phone numbers, and call reasons. Optionally filter by channel (phone/chat); None returns all channels. Requires \'call_log:view\' permission.
         * @summary Search Call Logs
         * @param {string} q Search query (names, phone numbers, reasons)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [agentId] Filter by specific agent
         * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
         * @param {boolean} [includeSuggestions] Include search suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCallLogsApiV1CallLogsSearchGet(q: string, limit?: number, offset?: number, agentId?: string | null, channel?: ChannelType | null, includeSuggestions?: boolean, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallLogSearchResponseDTO> {
            return localVarFp.searchCallLogsApiV1CallLogsSearchGet(q, limit, offset, agentId, channel, includeSuggestions, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search call logs using full-text search and pattern matching. Supports searching by caller names, phone numbers, and call reasons. Optionally filter by channel (phone/chat); None returns all channels. Requires \'call_log:view\' permission.
         * @summary Search Call Logs
         * @param {string} q Search query (names, phone numbers, reasons)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [agentId] Filter by specific agent
         * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
         * @param {boolean} [includeSuggestions] Include search suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCallLogsApiV1CallLogsSearchGet_14(q: string, limit?: number, offset?: number, agentId?: string | null, channel?: ChannelType | null, includeSuggestions?: boolean, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<CallLogSearchResponseDTO> {
            return localVarFp.searchCallLogsApiV1CallLogsSearchGet_14(q, limit, offset, agentId, channel, includeSuggestions, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CallLogsApi - object-oriented interface
 * @export
 * @class CallLogsApi
 * @extends {BaseAPI}
 */
export class CallLogsApi extends BaseAPI {
    /**
     * Create a new call log. Requires \'call_log:write\' permission.
     * @summary Create Call Log
     * @param {CallLogCreateDTO} callLogCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public createCallLogApiV1CallLogsPost(callLogCreateDTO: CallLogCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).createCallLogApiV1CallLogsPost(callLogCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new call log. Requires \'call_log:write\' permission.
     * @summary Create Call Log
     * @param {CallLogCreateDTO} callLogCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public createCallLogApiV1CallLogsPost_1(callLogCreateDTO: CallLogCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).createCallLogApiV1CallLogsPost_1(callLogCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a call log with its associated conversation data (GDPR-compliant deletion).  **GDPR Compliance**: Permanently deletes the call log and associated conversation data.  **What gets deleted:** - Call log record - Conversation transcript - All conversation turns - Additional answers  **What gets preserved:** - Contact record (unaffected) - Callbacks (call_log_id set to NULL, can still be accessed) - Calendar events/appointments (unaffected)  **Permissions**: Requires `call_log:write` permission  **Multi-tenant**: Automatically filtered to current organization  **Audit Logging**: This operation is logged with full context for compliance audit.
     * @summary Delete Call Log
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public deleteCallLogApiV1CallLogsCallLogIdDelete(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).deleteCallLogApiV1CallLogsCallLogIdDelete(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a call log with its associated conversation data (GDPR-compliant deletion).  **GDPR Compliance**: Permanently deletes the call log and associated conversation data.  **What gets deleted:** - Call log record - Conversation transcript - All conversation turns - Additional answers  **What gets preserved:** - Contact record (unaffected) - Callbacks (call_log_id set to NULL, can still be accessed) - Calendar events/appointments (unaffected)  **Permissions**: Requires `call_log:write` permission  **Multi-tenant**: Automatically filtered to current organization  **Audit Logging**: This operation is logged with full context for compliance audit.
     * @summary Delete Call Log
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public deleteCallLogApiV1CallLogsCallLogIdDelete_2(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).deleteCallLogApiV1CallLogsCallLogIdDelete_2(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Queue a dry-run replay of post-processing for an existing call log. Requires \'call_log:write\' permission.
     * @summary Enqueue Post Processing Dry Run
     * @param {string} callLogId 
     * @param {PostProcessingDryRunRequestDTO} postProcessingDryRunRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost(callLogId: string, postProcessingDryRunRequestDTO: PostProcessingDryRunRequestDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost(callLogId, postProcessingDryRunRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Queue a dry-run replay of post-processing for an existing call log. Requires \'call_log:write\' permission.
     * @summary Enqueue Post Processing Dry Run
     * @param {string} callLogId 
     * @param {PostProcessingDryRunRequestDTO} postProcessingDryRunRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost_3(callLogId: string, postProcessingDryRunRequestDTO: PostProcessingDryRunRequestDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).enqueuePostProcessingDryRunApiV1CallLogsCallLogIdPostProcessingDryRunPost_3(callLogId, postProcessingDryRunRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the action associated with a call log. Returns None if no action is associated. Requires \'call_log:view\' permission.
     * @summary Get Call Log Action
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public getCallLogActionApiV1CallLogsCallLogIdActionGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).getCallLogActionApiV1CallLogsCallLogIdActionGet(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the action associated with a call log. Returns None if no action is associated. Requires \'call_log:view\' permission.
     * @summary Get Call Log Action
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public getCallLogActionApiV1CallLogsCallLogIdActionGet_4(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).getCallLogActionApiV1CallLogsCallLogIdActionGet_4(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all additional answers for a call log. Requires \'call_log:view\' permission.
     * @summary Get Call Log Answers
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all additional answers for a call log. Requires \'call_log:view\' permission.
     * @summary Get Call Log Answers
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet_5(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).getCallLogAnswersApiV1CallLogsCallLogIdAnswersGet_5(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific call log by ID. Requires \'call_log:view\' permission.
     * @summary Get Call Log
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public getCallLogApiV1CallLogsCallLogIdGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).getCallLogApiV1CallLogsCallLogIdGet(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific call log by ID. Requires \'call_log:view\' permission.
     * @summary Get Call Log
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public getCallLogApiV1CallLogsCallLogIdGet_6(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).getCallLogApiV1CallLogsCallLogIdGet_6(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statistics for a call log search query. Requires \'call_log:view\' permission.
     * @summary Get Call Log Search Stats
     * @param {string} q Search query
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public getCallLogSearchStatsApiV1CallLogsSearchStatsGet(q: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).getCallLogSearchStatsApiV1CallLogsSearchStatsGet(q, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statistics for a call log search query. Requires \'call_log:view\' permission.
     * @summary Get Call Log Search Stats
     * @param {string} q Search query
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public getCallLogSearchStatsApiV1CallLogsSearchStatsGet_7(q: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).getCallLogSearchStatsApiV1CallLogsSearchStatsGet_7(q, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get search suggestions for call logs based on partial query. Requires \'call_log:view\' permission.
     * @summary Get Call Log Search Suggestions
     * @param {string} q Partial search query
     * @param {number} [maxSuggestions] Maximum suggestions
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet(q: string, maxSuggestions?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet(q, maxSuggestions, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get search suggestions for call logs based on partial query. Requires \'call_log:view\' permission.
     * @summary Get Call Log Search Suggestions
     * @param {string} q Partial search query
     * @param {number} [maxSuggestions] Maximum suggestions
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet_8(q: string, maxSuggestions?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).getCallLogSearchSuggestionsApiV1CallLogsSearchSuggestionsGet_8(q, maxSuggestions, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a call log with all related details (answers) loaded. Requires \'call_log:view\' permission.
     * @summary Get Call Log With Details
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a call log with all related details (answers) loaded. Requires \'call_log:view\' permission.
     * @summary Get Call Log With Details
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet_9(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).getCallLogWithDetailsApiV1CallLogsCallLogIdDetailsGet_9(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the full ordered post-processing history for a call log. Requires \'call_log:view\' permission.
     * @summary Get Post Processing History
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the full ordered post-processing history for a call log. Requires \'call_log:view\' permission.
     * @summary Get Post Processing History
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet_10(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).getPostProcessingHistoryApiV1CallLogsCallLogIdPostProcessingLogsGet_10(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all call logs in the current user\'s organization. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound) and channel (phone/chat). Requires \'call_log:view\' permission.
     * @summary List Call Logs
     * @param {CallLogSortField} [sortField] Field to sort by
     * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
     * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
     * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public listCallLogsApiV1CallLogsGet(sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, channel?: ChannelType | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).listCallLogsApiV1CallLogsGet(sortField, sortDirection, callDirection, channel, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all call logs in the current user\'s organization. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound) and channel (phone/chat). Requires \'call_log:view\' permission.
     * @summary List Call Logs
     * @param {CallLogSortField} [sortField] Field to sort by
     * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
     * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
     * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public listCallLogsApiV1CallLogsGet_11(sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, channel?: ChannelType | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).listCallLogsApiV1CallLogsGet_11(sortField, sortDirection, callDirection, channel, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List call logs for a specific agent. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
     * @summary List Call Logs By Agent
     * @param {string} agentId 
     * @param {CallLogSortField} [sortField] Field to sort by
     * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
     * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public listCallLogsByAgentApiV1CallLogsAgentAgentIdGet(agentId: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).listCallLogsByAgentApiV1CallLogsAgentAgentIdGet(agentId, sortField, sortDirection, callDirection, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List call logs for a specific agent. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
     * @summary List Call Logs By Agent
     * @param {string} agentId 
     * @param {CallLogSortField} [sortField] Field to sort by
     * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
     * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public listCallLogsByAgentApiV1CallLogsAgentAgentIdGet_12(agentId: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).listCallLogsByAgentApiV1CallLogsAgentAgentIdGet_12(agentId, sortField, sortDirection, callDirection, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List call logs from a specific phone number. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
     * @summary List Call Logs By Phone
     * @param {string} phoneNumber 
     * @param {CallLogSortField} [sortField] Field to sort by
     * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
     * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet(phoneNumber: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet(phoneNumber, sortField, sortDirection, callDirection, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List call logs from a specific phone number. Supports sorting by started_at and finished_at fields. Optionally filter by call direction (inbound/outbound). Requires \'call_log:view\' permission.
     * @summary List Call Logs By Phone
     * @param {string} phoneNumber 
     * @param {CallLogSortField} [sortField] Field to sort by
     * @param {SortDirection} [sortDirection] Sort direction (asc/desc)
     * @param {CallDirection | null} [callDirection] Filter by call direction (inbound/outbound)
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet_13(phoneNumber: string, sortField?: CallLogSortField, sortDirection?: SortDirection, callDirection?: CallDirection | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).listCallLogsByPhoneApiV1CallLogsPhonePhoneNumberGet_13(phoneNumber, sortField, sortDirection, callDirection, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search call logs using full-text search and pattern matching. Supports searching by caller names, phone numbers, and call reasons. Optionally filter by channel (phone/chat); None returns all channels. Requires \'call_log:view\' permission.
     * @summary Search Call Logs
     * @param {string} q Search query (names, phone numbers, reasons)
     * @param {number} [limit] Maximum number of results
     * @param {number} [offset] Number of results to skip
     * @param {string | null} [agentId] Filter by specific agent
     * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
     * @param {boolean} [includeSuggestions] Include search suggestions
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public searchCallLogsApiV1CallLogsSearchGet(q: string, limit?: number, offset?: number, agentId?: string | null, channel?: ChannelType | null, includeSuggestions?: boolean, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).searchCallLogsApiV1CallLogsSearchGet(q, limit, offset, agentId, channel, includeSuggestions, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search call logs using full-text search and pattern matching. Supports searching by caller names, phone numbers, and call reasons. Optionally filter by channel (phone/chat); None returns all channels. Requires \'call_log:view\' permission.
     * @summary Search Call Logs
     * @param {string} q Search query (names, phone numbers, reasons)
     * @param {number} [limit] Maximum number of results
     * @param {number} [offset] Number of results to skip
     * @param {string | null} [agentId] Filter by specific agent
     * @param {ChannelType | null} [channel] Filter by channel (phone/chat)
     * @param {boolean} [includeSuggestions] Include search suggestions
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public searchCallLogsApiV1CallLogsSearchGet_14(q: string, limit?: number, offset?: number, agentId?: string | null, channel?: ChannelType | null, includeSuggestions?: boolean, authorization?: string, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).searchCallLogsApiV1CallLogsSearchGet_14(q, limit, offset, agentId, channel, includeSuggestions, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

